import { onUnmounted, ref } from 'vue'
import { device } from '@/store/device'
import { user } from '@/store'
import * as api from '@/api'

/**
 * 允许从小程序转发的 H5 路径。
 * 新增页面时在这里加一条，并在小程序 src/utils/share.ts 的 SHARE_PAGES 同步加上。
 * 路径按 pathname 匹配，/topic 会同时匹配 /topic 和 /topic/1。
 */
export const SHARE_PAGES = ['/goods-detail']

/** 当前订货会是否允许小程序转发。0 关闭，1 开启 */
export const goodsShareStatus = ref(0)

export function isSharePage(path?: string) {
  if (!path) return false
  if (path.indexOf('://') >= 0 || path.indexOf('//') === 0 || path.indexOf('..') >= 0) {
    return false
  }
  const pathname = path.split('?')[0].split('#')[0]
  if (pathname.charAt(0) !== '/') return false
  return SHARE_PAGES.some((page) => pathname === page || pathname.indexOf(page + '/') === 0)
}

function postToMiniProgram(data: Record<string, unknown>) {
  if (!device.isWeChatMini) return
  try {
    wx.miniProgram.postMessage({
      data: {
        goods_share_status: goodsShareStatus.value,
        fair_id: user.selectMeeting || '',
        ...data,
      },
    })
  } catch (e) {}
}

export function postMiniProgramShare(payload: {
  title: string
  path: string
  imageUrl?: string
}) {
  if (!isSharePage(payload.path)) return
  postToMiniProgram({
    type: 'onShareAppMessage',
    title: payload.title,
    path: payload.path,
    imageUrl: payload.imageUrl || '',
  })
}

export function clearMiniProgramShare() {
  postToMiniProgram({
    type: 'clearShare',
  })
}

let shareStatusSeq = 0

export function syncMiniProgramShareStatus(status: unknown) {
  const next = Number(status) === 1 ? 1 : 0
  goodsShareStatus.value = next
  postToMiniProgram({
    type: 'shareConfig',
    goods_share_status: next,
  })
}

/** 按当前订货会拉配置。没有订货会、请求失败、字段不是 1，都按关闭 */
export async function refreshMiniProgramShareStatus() {
  const seq = ++shareStatusSeq
  if (!device.isWeChatMini) return
  if (!user.token || !user.selectMeeting || !user.selectShop) {
    if (seq !== shareStatusSeq) return
    syncMiniProgramShareStatus(0)
    return
  }
  try {
    const { data, error } = await api.order.getReportRankConfig({
      fair_id: user.selectMeeting,
      shop_id: user.selectShop,
    })
    if (seq !== shareStatusSeq) return
    syncMiniProgramShareStatus(!error && Number(data?.goods_share_status) === 1 ? 1 : 0)
  } catch (e) {
    if (seq !== shareStatusSeq) return
    syncMiniProgramShareStatus(0)
  }
}

/** 离开页面时清掉分享，避免下一页还带着上一页的卡片 */
export function useMiniProgramShare() {
  onUnmounted(() => {
    clearMiniProgramShare()
  })
}
